module.exports = __webpack_public_path__ + "img/whyBlue.6d646ece.jpg";